import { Injectable, Signal, signal } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiUrlService {
  private readonly _base = signal<string>(this.resolveInitialBase());

  readonly baseUrl: Signal<string> = this._base.asReadonly();

  buildUrl(path: string): string {
    const cleanPath: string = path.startsWith('/') ? path : `/${path}`;
    return `${this._base()}${cleanPath}`;
  }

  setOverride(url: string): void {
    if (localStorage.getItem('__sunny_dev_override') !== 'true') {
      console.warn('[ApiUrlService] setOverride ignored: set localStorage.__sunny_dev_override=true to enable');
      return;
    }
    this._base.set(url);
    localStorage.setItem('__sunny_api_override_url', url);
  }

  clearOverride(): void {
    this._base.set(environment.beApiUrl);
    localStorage.removeItem('__sunny_api_override_url');
  }

  private resolveInitialBase(): string {
    try {
      const devEnabled: boolean = localStorage.getItem('__sunny_dev_override') === 'true';
      if (devEnabled) {
        const saved: string | null = localStorage.getItem('__sunny_api_override_url');
        if (saved) return saved;
      }
    } catch {
      // localStorage unavailable (SSR or restricted context)
    }
    return environment.beApiUrl;
  }
}
